import { FC } from 'react';
import { Nullable } from '@/model/Common.model';
import { TaskTimeDuration } from '@/model/Task.model';
import { DateUtils, TimeFormat } from '@/utils/Date.utils';

export const TaskSpecTimeCell: FC<{ time: Nullable<TaskTimeDuration> }> = ({ time }) => {
  switch (time?.type) {
    case 'all_day':
      return 'All Day';
    case 'timed':
      return (
        DateUtils.renderTime(time.from, { defaultResponse: '-', format: TimeFormat.Time_24HR }) +
        ' - ' +
        DateUtils.renderTime(time.to, { defaultResponse: '-', format: TimeFormat.Time_24HR })
      );
    default:
      return null;
  }
};
